<style scoped>
@media(max-width: 575px) {
  .disclaimer-text>p {
    font-size: 12px;
  }
}

@media screen and (max-width: 768px) {


  .disclaimer-img {
    padding: 24px 10px 0px !important;
  }

  .disclaimer-img img {
    width: 55px;
  }

  .disclaimer-section .d-flex {
    padding-right: 0px;
  }

}


.disclaimer-img {
  background: #fcb913;
  padding: 30px;
}

.disclaimer-text {
  color: #ffffff;
  background: #000000;
  border-right: 20px solid #fcb913;
  padding: 22px;
}

.disclaimer-text strong {
  font-size: 20px;
}
</style>

<template>
    <div class="row  ml-0 disclaimer-section mb-4">
        <div class="col-12 pl-0 d-flex">
          <div class="disclaimer-img">
            <img src="/assets/images/disclaimer_ico.png" />
          </div>
          <div class="disclaimer-text">
            <strong>DISCLAIMER</strong>
            <p>These are the preliminary results. We take fair play seriously, that is why we are currently running the ultimate verification process, which may take up to two weeks. Once completed, we will release the overall final results.</p>
          </div>
        </div>
      </div>
</template>

<script>
export default {
  name: 'EventNotice'
}
</script>